module.exports = __webpack_public_path__ + "static/media/german-number-1-10.f4985a9f.PNG";